import { render, staticRenderFns } from "./StaticIPAddresses.vue?vue&type=template&id=2461f85a&scoped=true&"
import script from "./StaticIPAddresses.ts?vue&type=script&lang=ts&"
export * from "./StaticIPAddresses.ts?vue&type=script&lang=ts&"
import style0 from "./StaticIPAddresses.vue?vue&type=style&index=0&id=2461f85a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461f85a",
  null
  
)

export default component.exports